module.exports = __webpack_public_path__ + "static/media/CustomIconMath.bf533bad.svg";